import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.047 3.431A8.5 8.5 0 0 1 10 .833a8.5 8.5 0 0 1 8.333 8.642V12.5a3.334 3.334 0 0 1-2.5 3.227v.523a2.5 2.5 0 0 1-2.302 2.492 1.67 1.67 0 0 1-1.448.841h-1.25a1.667 1.667 0 1 1 0-3.333h1.25c.609 0 1.141.326 1.432.813a.834.834 0 0 0 .652-.813v-.523A3.333 3.333 0 0 1 15 9.167a3.26 3.26 0 0 1 1.667.466v-.158A6.834 6.834 0 0 0 10 2.5a6.833 6.833 0 0 0-6.667 6.975v.158A3.26 3.26 0 0 1 5 9.167 3.333 3.333 0 1 1 1.667 12.5V9.475a8.5 8.5 0 0 1 2.38-6.044m1.879 7.683a1.667 1.667 0 1 0-1.852 2.772 1.667 1.667 0 0 0 1.852-2.772m8.148 2.772a1.667 1.667 0 1 0 1.852-2.772 1.667 1.667 0 0 0-1.852 2.772",
  "clip-rule": "evenodd"
}, null, -1), a = [
  l
];
function r(c, d) {
  return e(), o("svg", n, [...a]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
